/* eslint-disable array-callback-return */
import React, { useEffect, useState, memo } from "react";
import useStyles from "./styles";
import FooterMenuItem from "../FooterIMenutem";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { useHistory, useLocation } from "react-router-dom";
import { MENU_FOOTER_SHOW, MENU_FOOTER } from "../configPageContainer";

const FooterPage = props => {
	const classes = useStyles();
	const history = useHistory();
	const location = useLocation();
	const { business } = props;
	const { pathname } = location;

	const [show, setShow] = useState(true);

	useEffect(() => {
		setShow(MENU_FOOTER_SHOW.includes(pathname));
	}, [pathname]);

	const handleClickMenu = link => {
		history.push(link);
	};

	const checkLinkActive = link => {
		if (link === pathname) {
			return true;
		}
		return false;
	};

	const menuBussiness = business => {
		switch (business) {
			case "TAC": {
				return MENU_FOOTER;
			}
			case "THOPHAT": {
				return MENU_FOOTER?.map(item => {
					if (item?.link === "/carts") {
						return {
							...item,
							iconActive: Images.icCartActiveTP
						};
					}
					if (item?.link === "/home") {
						return {
							...item,
							iconActive: Images.icHomeActiveTP
						};
					}
					if (item?.link === "/user") {
						return {
							...item,
							iconActive: Images.icUserActiveTP
						};
					}
				});
			}
			case "SNACKING": {
				return MENU_FOOTER?.map(item => {
					if (item?.link === "/carts") {
						return {
							...item,
							iconActive: Images.icCartActiveCake
						};
					}
					if (item?.link === "/home") {
						return {
							...item,
							iconActive: Images.icHomeActiveCake
						};
					}
					if (item?.link === "/user") {
						return {
							...item,
							iconActive: Images.icUserActiveCake
						};
					}
				});
			}
			default:
				return MENU_FOOTER;
		}
	};

	return (
		show && (
			<Grid classes={{ root: classes.root }} container>
				<Grid classes={{ root: classes.rootFooter }}>
					{menuBussiness(business).map((menu, index) => (
						<FooterMenuItem
							key={index}
							quanlityMenu={
								menuBussiness(business)?.filter(
									item => item?.isShow
								).length
							}
							menu={menu}
							handleClickMenu={handleClickMenu}
							checkLinkActive={checkLinkActive}
						/>
					))}
				</Grid>
			</Grid>
		)
	);
};

export default memo(FooterPage);
